import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Grid, Segment, Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import CommonHelper from "~/utils/CommonHelper";
import Invoice from "~/models/Invoice/Invoice";

@observer
class InvoiceTable extends Component {
  render() {
    const { t, invoice } = this.props;

    const invoiceDetailsContent = (
      <Table basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="10">{t("description")}</Table.HeaderCell>
            <Table.HeaderCell width="3">{t("price")}</Table.HeaderCell>
            <Table.HeaderCell width="3" textAlign="left">
              {t("total")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {invoice.invoiceRows.map(invoiceRow => (
            <Table.Row key={`invoiceRow${invoiceRow.invoiceRowId}`}>
              <Table.Cell>{invoiceRow.description}</Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(parseFloat(invoiceRow.amount))}</Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(parseFloat(invoiceRow.amount))}</Table.Cell>
            </Table.Row>
          ))}
          {invoice.invoiceTaxs.length > 0 && (
            <Table.Row key="subtotal">
              <Table.Cell />
              <Table.Cell textAlign="right">
                <strong>{t("subtotal")}:</strong>
              </Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(invoice.subtotal)}</Table.Cell>
            </Table.Row>
          )}
          {invoice.invoiceTaxs.map(invoiceTax => (
            <Table.Row key={`invoiceTax${invoiceTax.invoiceTaxId}`}>
              <Table.Cell />
              <Table.Cell>{invoiceTax.displayName}</Table.Cell>
              <Table.Cell>{CommonHelper.currencyFormat(parseFloat(invoiceTax.amount))}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell textAlign="right">
              <strong>{t("total")}:</strong>
            </Table.HeaderCell>
            <Table.HeaderCell>{CommonHelper.currencyFormat(invoice.totalAmountWithTaxes)}</Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    );

    let invoicePaymentsContent = <Segment textAlign="center">{t("billingCentral:noInvoicePayments")}</Segment>;

    if (invoice.invoicePayments.length > 0) {
      invoicePaymentsContent = (
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width="10">{t("date")}</Table.HeaderCell>
              <Table.HeaderCell width="3">{t("currency")}</Table.HeaderCell>
              <Table.HeaderCell width="3" textAlign="left">
                {t("amount")}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {invoice.invoicePayments.map(invoicePayment => (
              <Table.Row key={`invoicePayment${invoicePayment.invoicePaymentId}`}>
                <Table.Cell>{invoicePayment.creationDts.format("lll")}</Table.Cell>
                <Table.Cell>{invoicePayment.currency.toUpperCase()}</Table.Cell>
                <Table.Cell>{CommonHelper.currencyFormat(parseFloat(invoicePayment.amount))}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell textAlign="right">
                <strong>{t("total")}:</strong>
              </Table.HeaderCell>
              <Table.HeaderCell>{CommonHelper.currencyFormat(invoice.amountPaid)}</Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      );
    }

    let invoicePaymentLogsContent = null;

    if (invoice.invoicePaymentLogs.length > 0) {
      invoicePaymentLogsContent = (
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width="4">{t("date")}</Table.HeaderCell>
              <Table.HeaderCell width="4">{t("from")}</Table.HeaderCell>
              <Table.HeaderCell width="5">{t("message")}</Table.HeaderCell>
              <Table.HeaderCell width="3" textAlign="left">
                {t("amount")}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {invoice.invoicePaymentLogs.map(invoicePaymentLog => (
              <Table.Row key={`invoicePaymentLog${invoicePaymentLog.invoicePaymentLogId}`}>
                <Table.Cell>{invoicePaymentLog.creationDts.format("lll")}</Table.Cell>
                <Table.Cell>{invoicePaymentLog.description.split(":")[0]}</Table.Cell>
                <Table.Cell>{invoicePaymentLog.message}</Table.Cell>
                <Table.Cell>{CommonHelper.currencyFormat(parseFloat(invoicePaymentLog.amount))}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      );
    }

    return (
      <>
        <Grid columns={2} divided>
          <Grid.Column>
            <h4>{t("details")}</h4>
            {invoiceDetailsContent}
          </Grid.Column>
          <Grid.Column>
            <h4>{t("payments")}</h4>
            {invoicePaymentsContent}
            {invoicePaymentLogsContent && (
              <>
                <h4>{t("logs")}</h4>
                {invoicePaymentLogsContent}
              </>
            )}
          </Grid.Column>
        </Grid>
      </>
    );
  }
}

InvoiceTable.propTypes = {
  t: PropTypes.func.isRequired,
  invoice: PropTypes.instanceOf(Invoice),
};

export default withTranslation()(InvoiceTable);
